import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';

import { FeaturePaginationComponent } from './feature-pagination.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [FeaturePaginationComponent],
  exports: [FeaturePaginationComponent],
  imports: [CommonModule, NgxPaginationModule, FormsModule, ReactiveFormsModule]
})
export class FeaturePaginationModule {}
